export class Backdrop {
    readonly backdropId = 'backdrop';
    readonly callbacks: Function[] = [];

    public show(): void {
        if (!this.exists()) {
            this.create();
        }
        document.body.classList.add('modal-open');
    }

    public hide(): void {
        if (!this.exists()) {
            return;
        }
        this.getElement().remove();
        document.body.classList.remove('modal-open');
    }

    private create(): void {
        let backdrop = document.createElement('div');
        backdrop.id = this.backdropId;
        document.body.append(backdrop);

        let menuBackdrop = document.createElement('div');
        menuBackdrop.classList.add('menu-backdrop');
        menuBackdrop.onclick = this.fireEvent.bind(this);
        backdrop.append(menuBackdrop);
    }

    private getElement(): HTMLElement | null {
        return document.getElementById(this.backdropId);
    }

    private exists(): boolean {
        return this.getElement() !== null;
    }

    private fireEvent(): void {
        this.callbacks.forEach((callback) => {
            callback();
        });
    }

    public addOnClickCallback(callback: () => void): void {
        this.callbacks.push(callback);
    }
}
